// graphql/queries.js - All GraphQL queries and mutations

export const CREATE_AVAILABILITY_MUTATION = `
  mutation CreateAvailability($input: AvailabilityInput!) {
    createAvailability(input: $input) {
      id
      name
      timezone
      days
      timeSlots {
        timeStart
        timeEnd
      }
      dayTimeSlots {
        day
        slots {
          timeStart
          timeEnd
        }
      }
      overrides {
        date
        timeSlots {
          timeStart
          timeEnd
        }
        isUnavailable
      }
    }
  }
`;

export const UPDATE_AVAILABILITY_MUTATION = `
  mutation UpdateAvailability($id: ID!, $input: AvailabilityInput!) {
    updateAvailability(id: $id, input: $input) {
      id
      name
      timezone
      days
      timeSlots {
        timeStart
        timeEnd
      }
      dayTimeSlots {
        day
        slots {
          timeStart
          timeEnd
        }
      }
      overrides {
        date
        timeSlots {
          timeStart
          timeEnd
        }
        isUnavailable
      }
    }
  }
`;

export const DELETE_AVAILABILITY_MUTATION = `
  mutation DeleteAvailability($id: ID!) {
    deleteAvailability(id: $id)
  }
`;

export const GET_ALL_AVAILABILITIES = `
  query GetAllAvailabilities($spaceId: ID) {
    getAllAvailabilities(spaceId: $spaceId) {
      id
      name
      timezone
      days
      timeSlots {
        timeStart
        timeEnd
      }
      dayTimeSlots {
        day
        slots {
          timeStart
          timeEnd
        }
      }
      overrides {
        date
        timeSlots {
          timeStart
          timeEnd
        }
        isUnavailable
      }
    }
  }
`;

export const GET_AVAILABILITY = `
  query GetAvailability($id: ID!) {
    getAvailability(id: $id) {
      id
      name
      timezone
      days
      timeSlots {
        timeStart
        timeEnd
      }
      overrides {
        date
        timeSlots {
          timeStart
          timeEnd
        }
        isUnavailable
      }
    }
  }
`;

// Team availability related GraphQL queries
export const GET_TEAMS_QUERY = `
  query GetTeams($spaceId: ID) {
    getTeams(spaceId: $spaceId) {
      id
      name
      members {
        id
        userId
        email
        role
        status
        user {
          id
          name
          email
        }
      }
    }
  }
`;

export const GET_BOOKINGS_BY_SPACE_QUERY = `
  query GetBookingsBySpace($spaceId: ID) {
    getBookingsBySpace(spaceId: $spaceId) {
      id
      eventTypeId
      date
      timeStart
      timeEnd
      name
      email
      status
      timezone
      eventType {
        id
        title
        availabilityId
        owner {
          id
          name
        }
      }
    }
  }
`;

export const GET_TEAM_AVAILABILITIES_QUERY = `
  query GetTeamAvailabilities($teamId: ID!) {
    getTeam(id: $teamId) {
      id
      name
      members {
        id
        userId
        user {
          id
          name
        }
      }
    }
  }
`;

export const GET_AVAILABILITIES_QUERY = `
  query GetAllAvailabilities($spaceId: ID) {
    getAllAvailabilities(spaceId: $spaceId) {
      id
      name
      timezone
      days
      timeSlots {
        timeStart
        timeEnd
      }
      dayTimeSlots {
        day
        slots {
          timeStart
          timeEnd
        }
      }
      overrides {
        date
        timeSlots {
          timeStart
          timeEnd
        }
        isUnavailable
      }
    }
  }
`;
